<template>
  <v-form>
    <v-container fluid>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-text-field
            v-model="item.name"
            :error-messages="nameErrors"
            :label="$t('profile.quality.name')"
            required
            @input="$v.item.name.$touch()"
            @blur="$v.item.name.$touch()"
          />
        </v-col>

        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="focusSelectItems"
            v-model="item.focus"
            :items="focusSelectItems"
            :error-messages="focusErrors"
            :no-data-text="$t('global.no_result')"
:placeholder="$t('global.no_select')"
clearable
            :label="$t('profile.quality.focusname')"
            item-text="name"
            item-value="@id"
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="layerSelectItems"
            v-model="item.layer"
            :items="layerSelectItems"
            :error-messages="layerErrors"
            :no-data-text="$t('global.no_result')"
:placeholder="$t('global.no_select')"
clearable
            :label="$t('profile.quality.layer')"
            item-text="height"
            item-value="@id"
          />
        </v-col>

        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="nozzleOutSelectItems"
            v-model="item.nozzleOut"
            :items="nozzleOutSelectItems"
            :error-messages="nozzleOutErrors"
            :no-data-text="$t('global.no_result')"
:placeholder="$t('global.no_select')"
clearable
            :label="$t('profile.quality.nozzleout')"
            item-text="size"
            item-value="@id"
          />
        </v-col>
      </v-row>

    </v-container>
    <Loading :visible="isLoading" />
  </v-form>
</template>

<script>
import has from 'lodash/has';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import Loading from '../../components/Loading';
import { mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';

export default {
  name: 'QualityForm',
  mixins: [validationMixin],
  components: {
    Loading
  },
  props: {
    values: {
      type: Object,
      required: true
    },

    errors: {
      type: Object,
      default: () => {}
    },

    initialValues: {
      type: Object,
      default: () => {}
    }
  },
  mounted() {
      this.focusGetSelectItems();
      this.layerGetSelectItems();
      this.nozzleOutGetSelectItems();
  },
  data() {
    return {
        name: null,
        focus: null,
        layer: null,
        nozzleOut: null,
    };
  },
  computed: {
      isLoading() {
        return (this.isLoading_qualityfocus ||
           this.isLoading_qualitylayer ||
           this.isLoading_nozzleout 
         );
      },
      ...mapFields('qualityfocus', {
        focusSelectItems: 'selectItems',
        isLoading_qualityfocus : 'isLoading'
      }),
      ...mapFields('qualitylayer', {
        layerSelectItems: 'selectItems',
        isLoading_qualitylayer : 'isLoading'
      }),
      ...mapFields('nozzleout', {
        nozzleOutSelectItems: 'selectItems',
        isLoading_nozzleout : 'isLoading'
      }),

    // eslint-disable-next-line
    item() {
      return this.initialValues || this.values;
    },

    nameErrors() {
      const errors = [];

      if (!this.$v.item.name.$dirty) return errors;

      has(this.violations, 'name') && errors.push(this.violations.name);

      !this.$v.item.name.required && errors.push(this.$t('global.field_required'));

      return errors;
    },
    focusErrors() {
      const errors = [];

      if (!this.$v.item.focus.$dirty) return errors;

      has(this.violations, 'focus') && errors.push(this.violations.focus);


      return errors;
    },
    layerErrors() {
      const errors = [];

      if (!this.$v.item.layer.$dirty) return errors;

      has(this.violations, 'layer') && errors.push(this.violations.layer);


      return errors;
    },
    nozzleOutErrors() {
      const errors = [];

      if (!this.$v.item.nozzleOut.$dirty) return errors;

      has(this.violations, 'nozzleOut') && errors.push(this.violations.nozzleOut);


      return errors;
    },

    violations() {
      return this.errors || {};
    }
  },
  methods: {
      ...mapActions({
        focusGetSelectItems: 'qualityfocus/fetchSelectItems'
      }),
      ...mapActions({
        layerGetSelectItems: 'qualitylayer/fetchSelectItems'
      }),
      ...mapActions({
        nozzleOutGetSelectItems: 'nozzleout/fetchSelectItems'
      }),
  },
  validations: {
    item: {
      name: {
        required,
      },
      focus: {
      },
      layer: {
      },
      nozzleOut: {
      },
    }
  }
};
</script>
